<template>
    <transition name="layer-loading-fade">
        <div v-if="loadingLayers.length" class="layer-loading" role="status" aria-live="polite">
            <font-awesome-icon icon="spinner" spin />
            <div class="layer-loading-text">
                <strong>Cargando la vista del mapa</strong>
                <span>{{ detail }}</span>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'LayerLoadingNotice',
    computed: {
        loadingLayers() {
            return this.$store.getters.getLoadingLayers || [];
        },
        detail() {
            var layers = this.loadingLayers;
            if (layers.length === 1) {
                var name = layers[0].name || layers[0].nombre;
                return name ? 'Ajustando la resolución de "' + name + '"' : 'Ajustando la resolución de la capa';
            }
            return 'Ajustando la resolución de ' + layers.length + ' capas';
        }
    }
}
</script>

<style lang="scss" scoped>
/* Mismo lenguaje visual que el aviso de geoprocesos, pero más abajo para que ambos
   puedan convivir sin taparse, y sin llegar al toast que ocupa el borde inferior. */
.layer-loading {
    position: fixed;
    top: 88px;
    left: 50%;
    transform: translateX(-50%);

    z-index: 10000;

    display: flex;
    align-items: center;
    gap: 12px;

    padding: 10px 18px;

    background: var(--color-navy, #0e2a40);
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(14, 42, 64, 0.35);

    color: #fff;
    pointer-events: none;
}

.layer-loading svg {
    color: var(--color-orange, #e8730c);
    font-size: 1.1rem;
}

.layer-loading-text {
    display: flex;
    flex-direction: column;
    gap: 1px;
    line-height: 1.3;

    strong {
        font-size: 0.9rem;
    }

    span {
        font-size: 0.78rem;
        opacity: 0.85;
    }
}

.layer-loading-fade-enter-active,
.layer-loading-fade-leave-active {
    transition: opacity 0.18s ease;
}

.layer-loading-fade-enter,
.layer-loading-fade-leave-to {
    opacity: 0;
}

@media only screen and (max-width: 640px) {
    .layer-loading {
        top: 72px;
        padding: 8px 14px;
        max-width: 88vw;
    }
}
</style>
